import { AdminGuard } from './guards/admin.guard';
import { MessagingService } from './services/messaging.service';
import { SettingsService } from './services/settings.service';
import { CompanyService } from './services/company.service';
import { MediaService } from './services/media.service';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, Http } from '@angular/http';

import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MaterialModule } from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FileDropModule } from 'ngx-file-drop/lib/ngx-drop';
import { WeatherService } from "./services/weather.service";
import { AppRoutes } from './app.routing';
import { AppComponent } from './app.component';
import { GlobalLayoutComponent } from './layouts/global/global-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { SharedModule } from './shared/shared.module';
import { FileItem } from './directives/file-item.directive';
import { UsersService } from './services/users.service';
import { AuthService } from './services/auth.service';
import { UploadService } from './services/upload.service';
import { AuthGuard} from './guards/auth.guard';
import { MembersComponent } from './layouts/members/members.component';
import { CompbarComponent } from './layouts/compbar/compbar.component';
import { WebComponent } from './layouts/web/web.component';
import 'hammerjs';





export const firebaseConfig = {
    apiKey: "AIzaSyA9YSzhfIpH_v8an2h9tK3fpnptIL6Hv9U",
    authDomain: "globaltree-75bc2.firebaseapp.com",
    databaseURL: "https://globaltree-75bc2.firebaseio.com",
    storageBucket: "globaltree-75bc2.appspot.com",
    messagingSenderId: "690348715860"
}

export function createTranslateLoader(http: Http) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
 //   AdminLayoutComponent,
    GlobalLayoutComponent,
    AuthLayoutComponent,
    MembersComponent,
    CompbarComponent,
    WebComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    RouterModule.forRoot(AppRoutes),
    FormsModule,
    ReactiveFormsModule,
    AngularFireModule.initializeApp(firebaseConfig),
    HttpModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [Http]
      }
    }),
    MaterialModule,
    FlexLayoutModule,
    FileDropModule,
  ],
  providers: [
    AngularFireAuth,
    AngularFireDatabase,
    UsersService,
    MediaService,
    AuthService,
    UploadService,
    WeatherService,
 //   MessagingService,
    CompanyService,
    AuthGuard,AdminGuard,
    SettingsService
   ],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/src/app/app.module.ts